import { Box, MenuItem, useClipboard, useToast } from "@chakra-ui/react";
import ButtonWithConfirm from "components/Button/ButtonWithConfirm";
import { VThreeDotMenu } from "components/Menu/ThreeDotMenu";
import { useRemoveByPrefixId } from "features/Resources/Shared/hooks";
import { PropsWithChildren } from "react";
import { Link, useNavigate } from "react-router";
import { actionTemplatePathById, fromActionPrefixId, isProcessed } from "features/Resources/Shared/helpers";
import { PrefixId } from "features/Resources/Shared/models";
import { confirmRemoveArgs } from "features/Resources/Shared/helpers/confirmationArgs";
import CaminoDelete from "components/Icon/CaminoDelete";
import MenuItemIcon from "components/Icon/MenuItemIcon";
import { TbTemplate } from "react-icons/tb";
import { CopyIcon } from "@chakra-ui/icons";
import { Meeting } from "../models";
import { useMeetingDetailQuery } from "../hooks";

interface MeetingThreeDotOptionMenuProps extends PropsWithChildren {
  meetingPrefixId: Meeting["prefixId"];
}

export default function MeetingThreeDotOptionMenu({ meetingPrefixId }: MeetingThreeDotOptionMenuProps) {
  const { resourceType, id } = fromActionPrefixId(meetingPrefixId as PrefixId);

  const { data: meeting } = useMeetingDetailQuery(id);
  const navigate = useNavigate();

  const { mutate: handleRemove } = useRemoveByPrefixId(meetingPrefixId, () => {
    navigate("/");
  });

  const { onCopy } = useClipboard(meeting?.videoConferencingUrl || "");
  const toast = useToast({
    status: "success",
    duration: 2000,
  });

  const handleCopy = () => {
    onCopy();
    toast({
      title: "Copied!",
      description: "Video Conferencing URL has been copied to your clipboard.",
    });
  };

  if (!meeting || isProcessed(meeting)) {
    return null;
  }

  return (
    <VThreeDotMenu inPortal>
      {meeting.videoConferencingUrl && (
        <Box onClick={handleCopy}>
          <MenuItem icon={<MenuItemIcon icon={CopyIcon} />}>
            Copy Video Conferencing URL
          </MenuItem>
        </Box>
      )}
      <MenuItem as={Link} to={actionTemplatePathById(meeting)} icon={<MenuItemIcon icon={TbTemplate} />}>
        View Template
      </MenuItem>
      <ButtonWithConfirm {...confirmRemoveArgs(resourceType as "meeting")} intent="confirmation" handleConfirm={() => handleRemove()}>
        <MenuItem icon={<MenuItemIcon icon={CaminoDelete} />}>Delete</MenuItem>
      </ButtonWithConfirm>
    </VThreeDotMenu>
  );
}
